export default __webpack_public_path__ + "static/media/lala.bad31c07.png";